import { SeaShippingRecommendations } from '@lune-fe/dapi-models'
import { Button, Text } from '@lune-fe/lune-ui-lib'
import { Box, Stack } from '@mui/material'

type Recommendation = {
    carrier: string
    sourcePort: string
    destinationPort: string
}

export const RecommendationsBox = ({
    recommendations,
    onClick,
}: {
    recommendations: SeaShippingRecommendations
    onClick: (recommendation: Recommendation) => void
}) => {
    return (
        <Stack gap={4}>
            <Text variant="h5">Hotspots and Recommendations</Text>
            <Stack gap={1}>
                {recommendations.recommendations.map((recommendation, index) => (
                    <Box
                        key={`recommendation-${index}`}
                        sx={{
                            backgroundColor: 'Grey100',
                            p: 2,
                            borderRadius: 2,
                            display: 'flex',
                            gap: 2,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            button: {
                                minWidth: '100px',
                            },
                        }}
                    >
                        <Text variant="body2">
                            Emissions from{' '}
                            <Text component="span" fontWeight={500}>
                                {recommendation.carrier}
                            </Text>{' '}
                            shipments between{' '}
                            <Text component="span" fontWeight={500}>
                                {recommendation.sourcePort}
                            </Text>{' '}
                            and{' '}
                            <Text component="span" fontWeight={500}>
                                {recommendation.destinationPort}
                            </Text>{' '}
                            are higher than other carriers used on this route.
                        </Text>
                        <Button variant={'contained'} onClick={() => onClick(recommendation)}>
                            Show me
                        </Button>
                    </Box>
                ))}
            </Stack>
        </Stack>
    )
}
